<template>
  <div class="order-detail-card-wrap" v-if="benefitList.length">
    <h5 class="card-title" style="margin-bottom:20px">定购权益</h5>
    <div class="detail-wrap equity-wrap">
      <p v-for="(item, index) in benefitList" :key="index">{{ item.name }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "equity",
  components: {},
  props: {
    benefitList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";

//订购权益
.equity-wrap {
  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #4c4f59;
    padding-left: 12px;
    padding-bottom: 10px;
    position: relative;
    &::before {
      content: "";
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #4c4f59;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-8px);
    }
  }
}
</style>
